<div class="ts-rail-card">
    <h3 class="ts-rail-card-title">Who to Follow</h3>

    <div class="ts-follow-list">
        <div *ngFor="let user of suggestedUsers"
             class="ts-follow-row"
             (click)="$event.stopPropagation()">
            <div class="ts-follow-avatar">
                <img [src]="'api/content/logo?userID=' + user.UserId" alt="">
            </div>
            <div class="ts-follow-meta">
                <p class="ts-follow-name text-truncate">{{ user?.ProfileName }}</p>
                <p class="ts-follow-handle text-truncate">&#64;{{ user?.UserName }}</p>
            </div>
            <button type="button"
                    class="ts-follow-btn"
                    (click)="followUser(user.UserId, false); $event.stopPropagation()">
                Follow
            </button>
        </div>
    </div>
</div>
